// // // // import { useParams } from "react-router-dom";
// // // // import { useEffect, useState } from "react";

// // // // export default function DynamicAltImage() {
// // // //   const { slug } = useParams();
// // // //   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

// // // //   useEffect(() => {
// // // //     const handleResize = () => setIsMobile(window.innerWidth < 768);
// // // //     window.addEventListener("resize", handleResize);
// // // //     return () => window.removeEventListener("resize", handleResize);
// // // //   }, []);

// // // //   const imagePath = isMobile
// // // //     ? `/${slug}-mobile.png`
// // // //     : `/${slug}-desktop.png`;

// // // //   return (
// // // //     <div style={{ textAlign: "center"}}>
// // // //       <img
// // // //         src={imagePath}
// // // //         alt={slug}
// // // //         style={{
// // // //           maxWidth: "100%",
// // // //           height: "auto",
// // // //           display: "block",
// // // //           margin: "auto",
// // // //         }}
// // // //         onError={(e) => {
// // // //           e.currentTarget.style.display = "none";
// // // //           console.warn("Resim bulunamadı:", imagePath);
// // // //         }}
// // // //       />
// // // //     </div>
// // // //   );
// // // // }
// // // import { useParams } from "react-router-dom";
// // // import { useEffect, useState } from "react";

// // // export default function DynamicAltImage() {
// // //   const { slug } = useParams();
// // //   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
// // //   const [fallback, setFallback] = useState(false);

// // //   useEffect(() => {
// // //     const handleResize = () => setIsMobile(window.innerWidth < 768);
// // //     window.addEventListener("resize", handleResize);
// // //     return () => window.removeEventListener("resize", handleResize);
// // //   }, []);

// // //   const defaultImage = isMobile
// // //     ? "/images/8.png"
// // //     : "/images/slider1.png";

// // //   const imagePath = fallback
// // //     ? defaultImage
// // //     : `/${slug}-${isMobile ? "mobile" : "desktop"}.png`;

// // //   return (
// // //     <div style={{ textAlign: "center" }}>
// // //       <img
// // //         src={imagePath}
// // //         alt={slug}
// // //         style={{
// // //           maxWidth: "100%",
// // //           height: "auto",
// // //           display: "block",
// // //           margin: "auto",
// // //         }}
// // //         onError={() => {
// // //           if (!fallback) {
// // //             setFallback(true); // Fallback'a geçiş yap
// // //             console.warn("Resim bulunamadı, yedeğe geçiliyor:", imagePath);
// // //           }
// // //         }}
// // //       />
// // //     </div>
// // //   );
// // // }
// // import { useParams } from "react-router-dom";
// // import { useEffect, useState } from "react";

// // export default function DynamicAltImage() {
// //   const { slug } = useParams();
// //   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
// //   const [fallback, setFallback] = useState(false);

// //   useEffect(() => {
// //     const handleResize = () => setIsMobile(window.innerWidth < 768);
// //     window.addEventListener("resize", handleResize);
// //     return () => window.removeEventListener("resize", handleResize);
// //   }, []);

// //   const defaultImage = isMobile
// //     ? "/images/98.webp"          // 720x900
// //     : "/images/slider1.png";   // 2880x1440

// //   const imagePath = fallback
// //     ? defaultImage
// //     : `/${slug}-${isMobile ? "mobile" : "desktop"}.png`;

// //   const imageSize = isMobile
// //     ? { width: 720, height: 900, aspectRatio: "4/5" }
// //     : { width: 2880, height: 1440, aspectRatio: "2/1" };

// //   return (
// //     <div className={`w-full mx-auto aspect-[${imageSize.aspectRatio}] relative`}>
// //       <img
// //         src={imagePath}
// //         alt={slug}
// //         width={imageSize.width}
// //         height={imageSize.height}
// //         loading="lazy"
// //         className="absolute top-0 left-0 w-full h-full object-cover"
// //         onError={() => {
// //           if (!fallback) {
// //             setFallback(true);
// //             console.warn("Resim bulunamadı, yedeğe geçiliyor:", imagePath);
// //           }
// //         }}
// //       />
// //     </div>
// //   );
// // }
// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";

// export default function DynamicAltImage() {
//   const { slug } = useParams();
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [fallback, setFallback] = useState(false);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     setFallback(false);
//   }, [slug, isMobile]);

//   const defaultImage = isMobile
//     ? "/images/99.webp"
//     : "/images/slider1.png";

//   const imagePath = fallback
//     ? defaultImage
//     : `/${slug}-${isMobile ? "mobile" : "desktop"}.webp`;

//   return (
//     <div
//       className="w-full mx-auto relative overflow-hidden"
//       style={{ aspectRatio: isMobile ? "4 / 5" : "2 / 1" }}
//     >
//       <img
//         src={imagePath}
//         alt={slug}
//         loading="lazy"
//         className="absolute inset-0 w-full h-full object-cover"
//         onError={() => {
//           if (!fallback) {
//             setFallback(true);
//             console.warn("Resim bulunamadı, yedeğe geçiliyor:", imagePath);
//           }
//         }}
//       />
//     </div>
//   );
// }


import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function DynamicAltImage() {
  const { slug } = useParams();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setFallback(false);
  }, [slug, isMobile]);

  const defaultImage = isMobile
    ? "/images/99.webp"
    : "/images/slider1.png";

  const imagePath = fallback
    ? defaultImage
    : `/images/${slug}-${isMobile ? "mobile" : "desktop"}.webp`;

  return (
    <div
      className="w-full mx-auto relative overflow-hidden"
      style={{ aspectRatio: isMobile ? "4 / 7" : "2 / 1" }}
    >
      <img
        src={imagePath}
        alt={slug}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        onError={() => {
          if (!fallback) {
            setFallback(true);
            console.warn("Resim bulunamadı, yedeğe geçiliyor:", imagePath);
          }
        }}
      />
    </div>
  );
}